module.exports = __webpack_public_path__ + "media/images/flags/TK-13cd78e72dcf658b612b7ea02077b39d.svg";